import React from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import Container from '@material-ui/core/Container';
import { useTheme, useMediaQuery } from '@material-ui/core';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { useLocation } from 'react-router';
import queryString from 'query-string';
import { AppState } from '../../../redux/reducers';
import { fetchThunk } from '../../common/redux/thunk';
import HomeBox from '../components/HomePage/HomeBox';
import HomeBanner from '../components/HomePage/HomeBanner';
import HomeSearch from '../components/HomePage/HomeSearch';
import { API_PATHS } from '../../../configs/API';
import { MIX_PANEL_TRACK, SUCCESS_CODE } from '../../../constants';
import { Mixpanel } from '../../../configs/mixpanel';

interface Props {}

const Home: React.FC<Props> = (props) => {
  const dispatch = useDispatch<ThunkDispatch<AppState, null, Action<string>>>();
  const intl = useIntl();
  const [restaurants, setRestaurants] = React.useState([]);
  const [locations, setLocations] = React.useState([]);
  const [cuisines, setCuisines] = React.useState([]);

  const [loading, setLoading] = React.useState(true);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const location = useLocation();

  const fetchRestaurant = React.useCallback(async () => {
    const json = await dispatch(fetchThunk(API_PATHS.homeList, 'get'));
    if (json?.code === SUCCESS_CODE) {
      setRestaurants(json?.data);
    }
    setTimeout(() => {
      setLoading(false);
    }, 300);
  }, [dispatch]);

  const fetchLocation = React.useCallback(async () => {
    const json = await dispatch(fetchThunk(`${API_PATHS.getAllLocation}?country_code=VN`, 'get'));
    if (json?.code === SUCCESS_CODE) {
      setLocations(json?.data?.items);
    }
  }, [dispatch]);

  const fetchAttributes = React.useCallback(async () => {
    const json = await dispatch(fetchThunk(`${API_PATHS.getAllCuisines}`, 'get'));
    if (json?.code === SUCCESS_CODE) {
      setCuisines(json?.data?.items);
    }
  }, [dispatch]);

  React.useEffect((): void => {
    fetchRestaurant();
  }, [fetchRestaurant, intl]);

  React.useEffect((): void => {
    fetchAttributes();
  }, [fetchAttributes, intl]);

  React.useEffect((): void => {
    fetchLocation();
  }, [fetchLocation, dispatch, intl]);

  React.useEffect((): void => {
    const queryParams = queryString.parse(location.search);
    Object.keys(queryParams).length &&
      sessionStorage.setItem('query-home', JSON.stringify(queryParams));
  }, [location.search]);

  React.useEffect(() => {
    Mixpanel.track(MIX_PANEL_TRACK.VISIT_HOME, '');
  }, []);
  return (
    <div className="home-container">
      <HomeBanner />
      <HomeSearch locations={locations} cuisines={cuisines} />
      <Container style={{ padding: 0, marginTop: !matches ? '40px' : '' }}>
        {!loading && restaurants.length
          ? restaurants.map((item: any, index) => (
              <HomeBox
                key={`home${index}`}
                restaurants={item.restaurants}
                title={item.name}
                iconLink={item.icon_url}
                subTitle={item.description}
              />
            ))
          : [1, 2].map((item: any, index) => (
              <HomeBox key={`home${index}`} restaurants={[]} title="" iconLink="" subTitle="" />
            ))}
      </Container>
    </div>
  );
};

export default Home;
